import React from "react";

// Components
import Img from "components/Img";

export const InStock: React.FC = () => {
  return (
    <div className="status__wrapper-icon flex flex-ai-center flex-jc-start">
      <Img
        isSvg
        name="doneSvg"
        alt="Done icon"
      />
      <p className="status__text">In Stock</p>
    </div>
  );
};

export default InStock;